import { useEffect, useState } from "react";
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import OSM from 'ol/source/OSM';
import Feature from 'ol/Feature.js';
import {transformExtent} from 'ol/proj.js';
import LabeledValue from "../controls/LabeledValue";
import { Vector as VectorSource} from 'ol/source.js';
import "./SpatialExtent.css";
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer.js';
import {fromExtent} from 'ol/geom/Polygon';
import {Attribution, defaults as defaultControls} from 'ol/control.js';

const SpatialExtent = ({ extent }) => {
  const [mapLoaded, setMapLoaded] = useState(false);


  function transform(extent) {
    return transformExtent(extent, 'EPSG:4326', 'EPSG:3857');
  }

  useEffect(() => {
  if (mapLoaded) {


  }
}, [mapLoaded, extent]);


  useEffect(() => {
    const onReady = () => setMapLoaded(true);

    const polygonFeature = new Feature({
      geometry: fromExtent(transform(extent.bbox[0]))
  });

    const vectorSource = new VectorSource({
      features: [polygonFeature],
    });

    const vectorLayer = new VectorLayer({
      source: vectorSource,
      extent: transform(extent.bbox[0]),
      
    });

    const attribution = new Attribution({
      collapsible: false,
    });

    const view = new View({
      center: [-6,3],
      zoom: 0,
    });
      const map = new Map({
        target: 'extent-map',
        controls: [new Attribution({collapsible: false,
          collapsed: false})],
        view: view,
        layers: [
          new TileLayer({
            source: new OSM({
            })
            
          }), vectorLayer
        ],
      });
    
      map.on('loadstart', function () {
        console.log("Loading");
      });
      map.on('loadend', function () {
        console.log("Loaded");
      });
     
  }, []);

  

  if (!extent) return null;

  return (
    <div>
      <LabeledValue label="Spatial Extent" />
      <div
        id="extent-map"
        style={{ width: "250px", height: "160px", border: "0.5px solid #ccc" }}
      ></div>
    </div>
  );
};

export default SpatialExtent;
